// PR 5: durable provenance chip rendered on the user message a conversation
// file was attached to. The payload also carries a content hash, but only
// display-safe facts (file name, format) are shown.
import { Paperclip } from 'lucide-react';
import type { ReactElement } from 'react';

import { useI18nSubscription } from '../../../i18n/useI18nSubscription.js';
import { i18n } from '../../../../i18n/index.js';

interface ChatFileAttachmentSnippetProps {
  fileName: string;
  format: string;
}

export function ChatFileAttachmentSnippet({
  fileName,
  format,
}: ChatFileAttachmentSnippetProps): ReactElement {
  useI18nSubscription();
  return (
    <span
      data-testid="chat-file-attachment-chip"
      className="inline-flex max-w-full items-center gap-1.5 rounded-full border border-stone-200 dark:border-stone-700 bg-stone-50 dark:bg-stone-800 px-2.5 py-1 text-xs font-medium text-stone-700 dark:text-stone-200"
    >
      <Paperclip size={12} aria-hidden="true" className="shrink-0" />
      <span className="truncate">
        {i18n.t('crm.ai_chat.file_input.attachment.chip', {
          fileName,
          format: format.toUpperCase(),
        })}
      </span>
    </span>
  );
}
